import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
  Paper,
  CircularProgress
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import apiUrl from '../../Config';
import { toast } from 'react-toastify';

const AddEditRadius = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const radiusData = state?.item;
  const [errors, setErrors] = useState('')
  const [loading, setLoading] = useState(false)

  const [formData, setFormData] = useState({
    id: 1,
    radiusKm: '',
    rangeFor: "",
    // status: true,
  });

  useEffect(() => {
    if (radiusData) {
      setFormData({
        id: radiusData?.id || '',
        radiusKm: radiusData?.radiusKm || '',
        rangeFor: radiusData?.rangeFor || '',
        // status: radiusData.status ?? true,
      });
    }
  }, [radiusData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true)

      const res = await axios.put(`${apiUrl}/radiussetting/updateradius/${formData.id}`, formData);
      if (res?.data?.status === true) {
        toast.success(res?.data?.message || 'Delivery range update successfully')
        navigate('/display-delivery-radius');
      }
    } catch (error) {
      setErrors(error?.res?.data?.message || "Update error:");
    }
    finally {
      setLoading(false)
    }
  };

  return (
    <Box p={3} maxWidth="500px" mr="auto">
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h5" mb={3}>
          Edit Delivery Radius
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            label="Radius (Km)"
            name="radiusKm"
            type="number"
            value={formData.radiusKm}
            onChange={handleChange}
            fullWidth
            required
            sx={{ mb: 2 }}
          />

          <TextField
            label="Range For"
            name="rangeFor"
            value={formData.rangeFor}
            onChange={handleChange}
            fullWidth
            required
            InputProps={{
              readOnly: true,
            }}
            sx={{ mb: 2 }}
          />
          <Box>
            {errors &&
              <Typography>{errors}</Typography>
            }
          </Box>
          <Box mt={3} display="flex" justifyContent="space-between">
            <Button type="submit" variant="contained" rangeFor>
              {loading ? (
                <CircularProgress size={24} sx={{ color: '#fff' }} />
              ) : (
                formData.id ? 'Update' : 'Create'
              )}
            </Button>
            <Button variant="outlined" color="secondary" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
};

export default AddEditRadius;
